import { LoadingLayout } from 'components';
import { useScrollToTop } from 'hooks';
import { ErrorFallback } from 'modules/App/ErrorFallback';

import { getLegalRepresentativeRepresentativeType } from '../helpers';
import { useLegalClientRepresentativeVersion } from '../hooks';
import { LegalRepresentativeVersionView } from '../views';

export const LegalRepresentativeVersionContainer = () => {
  const {
    initialValues,
    loading,
    error,
    versions,
    breadcrumbsTitles,
    snapshot,
    name,
    snapshotLoading,
    versionId,
    onChangeVersion,
    onCloseVersionHistory,
    legalClientRepresentative,
  } = useLegalClientRepresentativeVersion();

  useScrollToTop([]);

  if (error) {
    return <ErrorFallback />;
  }

  if (loading) {
    return <LoadingLayout />;
  }

  const representativeType = getLegalRepresentativeRepresentativeType(
    legalClientRepresentative
  );

  return (
    <LegalRepresentativeVersionView
      breadcrumbsTitles={breadcrumbsTitles}
      countries={[]}
      initialValues={initialValues}
      kycData={snapshot?.value.kyc}
      name={name}
      representativeType={representativeType}
      snapshotLoading={snapshotLoading}
      versionId={versionId}
      versions={versions ?? []}
      onChangeVersion={onChangeVersion}
      onCloseVersionHistory={onCloseVersionHistory}
    />
  );
};
